<p-table 
    class="w-100 p-0 m-0"
    [value]="data()"
    [rowsPerPageOptions]="lts.rowsPerPageOptions"
    [rows]="lts.pageSize"
    [totalRecords]="$safeNavigationMigration(lazyLoad()?.totalRecords)"
    (onPage)="lts.onPageChange($event, dataSource, tableInput, filters())" 
    [paginator]="true"
    [lazy]="true"
    (onLazyLoad)="getContactList()" 
    [filterDelay]="500"
    [rowHover]="!isLoading()"
    [scrollable]="true"
    scrollHeight="flex"
    stripedRows
    [dt]="tableDts"  
>

    <ng-template #caption>
        <div class="w-100 d-flex justify-content-between align-items-center">
            <h3>{{ isSelected() ? 'Selected' : 'Available' }} Contacts</h3>
            <div class="d-flex align-items-center">
                <p-floatlabel variant="on">
                    <input 
                        #searchInput
                        pInputText
                        type="search"
                        [ngModel]="filters().tableInput"
                        (ngModelChange)="filterSearch($event)"
                    />
                    <label for="searchInput">Search</label>
                </p-floatlabel>
            </div>
        </div>
    </ng-template>

    <ng-template #header>
        <tr>
            <th style="width: 40%">
                <div class="d-flex align-items-center justify-content-between">
                    Name
                </div>
            </th>
            <th style="width: 50%">
                Email
            </th>
            <th style="width: 10%">
                <div class="d-flex align-items-center justify-content-end">
                        <p-button 
                            (click)="toggleAll()"
                            size="small"
                            raised="true"
                            [label]="'All'"
                            [icon]="isSelected() ? 'pi pi-minus' : 'pi pi-plus'"
                            [severity]="isSelected() ? 'danger' : null"
                        />
                    </div>
            </th>
        </tr>
    </ng-template>

    <ng-template 
        #body 
        let-contact
    >
        <tr class="cursor-pointer" (click)="isLoading() ? null : toggleContact(contact)">
            @if (isLoading()) {
                <td colspan="999">
                    <p-skeleton />
                </td>
            } @else {
                <td style="width: 40%">
                    <div class="d-flex justify-content-between">
                        {{ contact.name }}                       
                    </div>
                </td>
                <td style="width: 50%">
                    {{ contact.email }}
                </td>
                <td style="width: 10%" class="text-right">
                    <i [ngClass]="isSelected() ? 'pi pi-minus-circle text-danger' : 'pi pi-plus-circle text-success'"></i>
                </td>
            }
        </tr>
    </ng-template>

    <ng-template #emptymessage>
        <tr>
            <td 
                class="text-center" 
                colspan="999"
            >No Contacts Found.</td> 
        </tr>
    </ng-template>    
</p-table>